import React from "react";

export default function Filter({extra}) {
  return (
    <div className={`hidden md:block w-[350px] h-full bg-white rounded-2xl shadow-lg py-4 px-6 ${extra}`}>
      <h2 className="mb-4 text-xl font-semibold">Filter</h2>

      {/* Popular Filters */}
      <div className="mb-4">
        <h3 className="mb-2 font-medium">Popular Filters</h3>
        <label className="mb-2 flex items-center space-x-2">
          <input type="checkbox" className="accent-[#2A2F8D]" />
          <span>Free Cancellation</span>
        </label>
        <label className="mb-2 flex items-center space-x-2">
          <input type="checkbox" className="accent-[#2A2F8D]" />
          <span>Break-Fast Included</span>
        </label>
      </div>

      <hr className="my-4 border-gray-300" />

      {/* Activity Filters */}
      <div className="mb-4">
        <h3 className="mb-2 font-medium">Activity Filters</h3>
        <label className="mb-2 flex items-center space-x-2">
          <input type="checkbox" className="accent-[#2A2F8D]" />
          <span>Arcade/Video Games</span>
        </label>
        <label className="mb-2 flex items-center space-x-2">
          <input type="checkbox" className="accent-[#2A2F8D]" />
          <span>Hiking Trail</span>
        </label>
        <label className="mb-2 flex items-center space-x-2">
          <input type="checkbox" className="accent-[#2A2F8D]" />
          <span>Yoga</span>
        </label>
      </div>

      <hr className="my-4 border-gray-300" />

      {/* Rating */}
      <div className="mb-4">
        <h3 className="mb-2 font-medium">Rating:</h3>
        <div className="mt-1 flex flex-wrap gap-2">
          {["0+", "1+", "2+", "3+", "4+"].map((rate) => (
            <span
              key={rate}
              className="cursor-pointer rounded border border-[#2A2F8D] px-3 py-1 text-sm font-medium transition hover:bg-[#2A2F8D] hover:text-white"
            >
              {rate}
            </span>
          ))}
        </div>
      </div>

      {/* Price */}
      <div className="mt-6">
        <h3 className="mb-2 font-medium">Price:</h3>
        <input
          type="range"
          min="500"
          max="5000"
          defaultValue="2499"
          className="w-full accent-[#2A2F8D]"
        />
        <div className="mt-1 flex justify-between text-sm text-gray-500">
          <span>₹500</span>
          <span>₹5000</span>
        </div>
      </div>
    </div>
  );
}
